import React from 'react';
import { Link } from 'react-router-dom';
import { Eye, ArrowLeft } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Dezenter Hinweis-Banner, der nur erscheint, wenn ein Admin/Super-Admin
 * eine öffentliche Seite (z. B. /seminare) im „Vorschau-Modus" betrachtet.
 * Ermöglicht den schnellen Rücksprung in den Admin-Bereich.
 */
export function AdminPreviewBanner({ backTo = '/admin', backLabel = 'Zurück zum Admin-Dashboard' }) {
    const { isAuthenticated, isAdmin } = useAuth();
    if (!isAuthenticated || !isAdmin()) return null;

    return (
        <div
            className="bg-amber-50 border-b border-amber-200 text-amber-900"
            data-testid="admin-preview-banner"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-between gap-3 flex-wrap">
                <div className="flex items-center gap-2 text-sm">
                    <Eye className="h-4 w-4 shrink-0" />
                    <span className="font-medium">Vorschau-Modus</span>
                    <span className="text-amber-800/80 hidden sm:inline">
                        – Sie sehen diese Seite, wie ein nicht angemeldeter Besucher sie sieht.
                    </span>
                </div>
                <Link
                    to={backTo}
                    className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-amber-100 hover:bg-amber-200 text-amber-900 text-xs font-semibold transition-colors"
                    data-testid="admin-preview-back-link"
                >
                    <ArrowLeft className="h-3.5 w-3.5" />
                    {backLabel}
                </Link>
            </div>
        </div>
    );
}

export default AdminPreviewBanner;
